/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Auto_DescInputs */

const en_simple_door_auto_desc = /** @type {(inputs: Simple_Door_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep works step by step; you approve each stage.`)
};

const id_simple_door_auto_desc = /** @type {(inputs: Simple_Door_Auto_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep mengerjakan langkah demi langkah, kamu tinggal menyetujui tiap tahap.`)
};

/**
* | output |
* | --- |
* | "Bystep works step by step; you approve each stage." |
*
* @param {Simple_Door_Auto_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_auto_desc = /** @type {((inputs?: Simple_Door_Auto_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Auto_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_auto_desc(inputs)
	return en_simple_door_auto_desc(inputs)
});